// 2s 后隐藏 toast
var HIDE_TOAST_DELAY = 2000; // toast 隐藏后等待 0.5s 再移除

var REMOVE_TOAST_DELAY = 500; // 多个 toast 之间的距离

var DEFAULT_MARGIN = 20; // toast 相对于 container 的默认 top

var DEFAULT_OFFSET_TOP = 233;

export { DEFAULT_MARGIN, DEFAULT_OFFSET_TOP, HIDE_TOAST_DELAY, REMOVE_TOAST_DELAY };
